import React from 'react';
import {useHistory} from 'react-router';
import {Translate} from '../../config/TranslationProvider';

const PageNotFound = () => {
    const history = useHistory();
    const handleToHomepageButton = () => {
        history.push('/');
    };
    return (
        <div className="pageNotFound">
            <div>
                <h1 style={{textAlign: 'center'}}><Translate value="page_not_found_headline" /></h1>
                <button className="btn btn-gradient btn-gradient-two btn-md btn_search" onClick={history.goBack}>
                    <Translate value="back" />
                </button>
                <button className="btn btn-gradient btn-gradient-two btn-md btn_search" onClick={handleToHomepageButton}>
                    <Translate value="homepage" />
                </button>
            </div>
        </div>
    );
};

export default PageNotFound;
